export const TARJETASCREDITO_BANNER = "/CDN/Get/cabecera_PaquetesNyP";
export const INCLUSIONFINANCIERA_BANNER = "/CDN/Get/cabezal_web_lineas_inclusion_financiera";
export const PRESTAMOPERSONAL_BANNER = "/CDN/Get/cabecera_PaquetesNyP";
export const CAJASSEGURIDAD_BANNER = "/CDN/Get/Caja_seguridad_headerinterna.jpg";
export const PAQUETES_BANCA_INDIVIDUO = "/CDN/Get/cabecera_PaquetesNyP";
export const PAQUETES_NYP = "/CDN/Get/cabecera_PaquetesNyP";
export const CANJE_POP_CDNI = "/CDN/Get/header_canje_pop";
export const ADJUDICACION_ANTICIPADA = "/CDN/Get/header_form_adj_anticipada";
export const CREDITO_IMPULSO = "/CDN/Get/cabecera_Credito_Impulso_al_Comercio_Bonaerense";
export const TARJETA_PACTAR_BANNER_XS = "/CDN/Get/banner_home_pactar_xs";
export const TARJETA_PACTAR_BANNER_S = "/CDN/Get/banner_home_pactar_s";
export const TARJETA_PACTAR_BANNER_M = "/CDN/Get/banner_home_pactar_m";
export const TARJETA_PACTAR_BANNER_L = "/CDN/Get/banner_home_pactar_l";
export const COMERCIO_PACTAR_BANNER_XS = "/CDN/Get/pactar_pactar_xs";
export const COMERCIO_PACTAR_BANNER_S = "/CDN/Get/pactar_pactar_s";
export const COMERCIO_PACTAR_BANNER_M = "/CDN/Get/pactar_pactar_m";
export const COMERCIO_PACTAR_BANNER_L = "/CDN/Get/pactar_pactar_l";
export const LINEA_DE_INVERSION = "/CDN/Get/header_form_linea_inversion";
export const DEMANDA_COLECTIVA_IFE = "/CDN/Get/header_form_demanda_colectiva_ife";
export const CERA = "/CDN/Get/header_form_cera";
export const PRESTAMO_A_DISTANCIA = "https://www.bancoprovincia.com.ar/CDN/Get/prestamo_aca_L";
export const PUSF_BANNER = "/CDN/Get/header_pusf";
export const ARREPENTIMIENTO="/CDN/Get/micrositio_arrepentimiento_form";
export const ADHESION_COMERCIOS="/CDN/Get/micrositio_adhesion";
export const ADHESION_COMERCIOS_FORM="/CDN/Get/micrositio_adhesion";
export const PROVINCIA_INTERGRA="/CDN/Get/banner_API";

export const APP_LEGALES_PRESTAMO_INV: string[] = [
  `
    (*) Conoc� los t�rminos y condiciones de la oferta haciendo click <a style='color: rgb(60, 60, 59);font-weight:bold' href='http://www.bancoprovincia.com.ar/web/legal_prestamo'>ac�</a>`,
  `El clic en ENVIAR implica conformidad para que los datos de esta presolicitud sean enviados al Banco de la Provincia de Buenos Aires y sin que ello importe su aceptaci�n. Asimismo, tomo conocimiento de los t�rminos y condiciones expuestos en la presente oferta y de la informaci�n necesaria para su correcta utilizaci�n, los riesgos derivados de su empleo y quien asume los mismos.
    El clic en IMPRIMIR me permite obtener una copia que tambi�n se encuentra a la disposici�n en <a style='color: rgb(60, 60, 59);font-weight:bold' href='http://www.bancoprovincia.com.ar/web/legal_prestamo'>www.bancoprovincia.com.ar/web/legal_prestamo</a>`,
];

export const CONFIRMACION_ENTRADAS = "/CDN/Get/lospiojos_header";

export const CONFIRMACION_ENTRADAS_VIG_START = new Date('2024-12-09');
export const CONFIRMACION_ENTRADAS_VIG_END = new Date('2025-01-25');
export const PERSONA_JURIDICA_BANNER = "/CDN/Get/cab_web_presolicitud_cuenta_empresa2";
